<template>
  <div id="detail-wrap2">
    <a class="close_btn" @click.prevent="back">
      <span>
        <i class="el-icon-close"></i>
      </span>
    </a>

    <div class="scroll_area">
      <div class="head_data">
        {{ detail.id }} - {{ detail.surname }} {{ detail.name }}（{{ detail.surname_kana }} {{ detail.name_kana }}）
        <span class="badge">{{ detail.contract_status_name }}</span>
      </div>
      <div class="text-right u-mb--15" v-if="showChangeContract">
        <el-button type="primary" size="small" @click="changeContract">信販から自社割賦へ変更</el-button>
      </div>
      <table class="table table-bordered">
        <tr>
          <th>会員番号</th>
          <td>{{ detail.number }}</td>
          <th>承認番号</th>
          <td>{{ detail.approval_number }}</td>
        </tr>
        <tr>
          <th>申込日</th>
          <td>{{ detail.apply_date | dateFormat('YYYY年MM月DD日') }}</td>
          <th>受付日</th>
          <td>{{ detail.reception_date | dateFormat('YYYY年MM月DD日') }}</td>
        </tr>
        <tr>
          <th>申込金額</th>
          <td>{{ detail.remaining_money_str }}</td>
          <th>状態</th>
          <td>{{ detail.contract_status_name }}</td>
        </tr>
        <tr>
          <th>キャンセル</th>
          <td>
            <template v-if="isCancelable">
              <el-button type="danger" size="small" @click="cancel" :disabled="!detail.can_cancel">
                {{ detail.cancel_status_name === '' ? 'キャンセル' : detail.cancel_status_name }}
              </el-button>
              <span class="cancel_notice" v-if="showCancelNotice(detail)"
                >{{ dateFormat(detail.closing_date, 'M月DD日') }}(締日)まではキャンセル可能</span
              >
            </template>
          </td>
          <th>商品</th>
          <td>
            <span v-for="product in detail.products" :key="product.id">
              {{ product.name }}
              <template v-if="product.product_other_name"> <br />{{ product.product_other_name }} </template>
            </span>
          </td>
        </tr>
        <tr>
          <th>PDF</th>
          <td>
            <a class="btn btn-primary btn-sm" :href="'/pdf/store/' + detail.id" target="_blank">お申込書控え</a>
          </td>
          <th>店舗</th>
          <td>{{ detail.branch.name }}</td>
        </tr>
        <tr>
          <th>契約情報</th>
          <td colspan="3">
            <el-button type="primary" size="small" @click="registPhoto">口座情報・写真追加</el-button>
            <el-button type="primary" size="small" @click="updateProduct" :disabled="!showUpdateBtn"
              >商品内容変更</el-button
            >
            <el-button type="primary" size="small" @click="updateCustomer" :disabled="!showUpdateBtn"
              >お客様情報変更</el-button
            >
            <span v-if="detail.contract_status_name === '承認'"
              >「承認」後は変更不可ですので、チャットにてご連絡ください。</span
            >
          </td>
        </tr>
      </table>

      <div class="chat-area">
        <div class="message_area">
          <el-input type="textarea" :rows="3" placeholder="チャットメッセージを入力" v-model="chatMessage"></el-input>
          <p class="admin_form_error_message" v-if="errors.message">{{ errors.message }}</p>
          <div class="send_btn">
            <el-button size="mini" @click="addMessage" v-bind:disabled="isMessageBtnPushed">
              <i class="el-icon-chat-line-round"></i> 送信する
            </el-button>
          </div>
        </div>

        <div class="messages">
          <div class="message" v-for="(row, index) in chatList" :key="index">
            <p class="signature jcg" v-if="row.type == 'COMPANY'">
              <el-checkbox v-model="row.is_readed" @change="changeRead(row)"
                >{{ row.account_name }} - {{ row.date | dateFormat('YYYY.MM.DD HH:mm') }}</el-checkbox
              >
            </p>
            <p class="signature store" v-if="row.type == 'STORE' || row.type == 'BRANCH'">
              <template v-if="row.is_readed"><span class="is_read">既読</span></template
              >{{ row.account_name }} - {{ row.date | dateFormat('YYYY.MM.DD HH:mm') }}
            </p>
            <p class="text">{{ row.message }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import {mapActions, mapGetters} from 'vuex'
import {
  TransUserInputFromWebApi,
  TransProductInputFromWebApi,
  TransUploadInputFromWebApi
} from '../../../util/member/formDataTransform'
import {Loading} from 'element-ui'
export default {
  data() {
    return {
      chatMessage: '',
      detailId: null,
      detail: {
        number: '',
        name: '',
        name_kana: '',
        apply_date: '',
        reception_date: '',
        money: '',
        status: '',
        product: '',
        store_name: '',
        branch: {
          name: ''
        },
        is_cancel: null
      },
      chatList: [],
      chatMessage: '',
      offsetDate: '',
      isLoading: false,
      isMessageBtnPushed: false,
      errors: {
        message: ''
      },
      interval: null
    }
  },
  mounted() {
    this.detailId = this.$router.currentRoute.params.id
    this.initialize()
  },
  unmounted(){
    clearInterval(this.interval)
  },
  methods: {
    back() {
      clearInterval(this.interval)
      this.$emit('back')
      this.transitionSame('list')
    },
    initialize() {
      axios.get('/api/store/contract/' + this.detailId).then((res) => {
        this.detail = res.data

        this.loadChat()
        // チャットデータ取得
        clearInterval(this.interval)
        this.interval = setInterval(this.loadChat, 15000)
      })
    },
    changeRead(chat) {
      axios
        .put('/api/store/contract/chat/' + this.$route.params.id + '/read', {
          chat_id: chat.id
        })
        .then((res) => {})
    },
    loadChat() {
      if (this.isLoading == true || typeof this.$route.params.id === 'undefined') {
        return
      }
      this.isLoading = true
      // とりあえずcontract idは固定
      axios
        .get('/api/store/contract/chat/' + this.$route.params.id, {
          params: {offset: this.offsetDate}
        })
        .then((res) => {
          this.chatList = res.data
          this.isLoading = false
        })
    },
    async addMessage() {
      this.isMessageBtnPushed = true
      const loadingItem = Loading.service({})
      await axios
        .post('/api/store/contract/chat/' + this.$route.params.id + '/add', {
          message: this.chatMessage
        })
        .then((res) => {
          this.chatMessage = ''
          this.loadChat()
        })
        .catch((err) => {
          if (err.response.status === 422) {
            const errors = err.response.data.errors
            _.each(errors, (value, key) => {
              this.errors[key] = value[0]
            })
          }
        })
      this.isMessageBtnPushed = false
      loadingItem.close()
    },
    cancel() {
      const _this = this
      this.$confirm('キャンセル依頼しますか？', 'ご確認ください。', {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'guide'
      })
        .then(() => {
          axios
            .put('/api/store/contract/cancel/' + this.$route.params.id)
            .then((res) => {
              this.detail.is_cancel = true
              this.detail.can_cancel = false
              this.$message(`キャンセル依頼を出しました。`)

              // キャンセル依頼のチャットメッセージを表示するためチャット再読み込み
              this.loadChat()
            })
            .catch((err) => {
              if (err.response.status === 409) {
                this.$alert('既にキャンセル依頼済みまたはキャンセル済みの為キャンセル依頼できません。', 'メッセージ', {
                  confirmButtonText: 'OK'
                })
                this.initialize()
              }
            })
        })
        .catch(() => {})
    },
    registPhoto() {
      clearInterval(this.interval)
      if (this.$route.name !== 'regist-photo') {
        this.$router.push({
          name: 'regist-photo',
          params: {id: this.$route.params.id}
        })
      }
    },
    updateProduct() {
      clearInterval(this.interval)
      if (this.$route.name !== 'update-product') {
        this.$router.push({
          name: 'update-product',
          params: {id: this.$route.params.id}
        })
      }
    },
    updateCustomer() {
      clearInterval(this.interval)
      if (this.$route.name !== 'update-customer') {
        this.$router.push({
          name: 'update-customer',
          params: {id: this.$route.params.id}
        })
      }
    },

    // 信用保証の契約を自社割賦の契約に変更する処理
    changeContract() {
      this.updateHasPayment('installment')
      this.updateHasRegistration('change')
      if (!Object.keys(this.customer_user).length) {
        this.$message.error('ユーザー情報が存在しません')
        return false
      }
      this.updateId(this.customer_user.id)

      const d = this.detail // 商品詳細
      const c = d.customer // 個人情報

      // 元の信用保証申込ID Store
      this.updateOriginalContractId(d.id)

      // 既存の申込 個人情報データ Store
      let userInput = TransUserInputFromWebApi(d, c, this.getHasPayment) // データ整形

      // 申込日を代入
      const applyDate = moment(d.apply_date, 'YYYY-MM-DD')
      userInput.application_date_year = applyDate.year().toString()
      userInput.application_date_month = (applyDate.month() + 1).toString()
      userInput.application_date_day = applyDate.date().toString()
      userInput.is_change_customer = 0
      this.userInputSetForm(userInput)

      // 既存の申込 商品データ Store
      const productForm = TransProductInputFromWebApi(d) // データ整形
      this.productInputSetForm(productForm)

      // 既存の申込 口座振替データ Store
      const uploadForm = TransUploadInputFromWebApi(d) // データ整形
      this.uploadInputSetForm(uploadForm)

      // 署名データ Store
      this.updateSign(c.sign_image)

      this.transitionSame('form-product-input')
    },
    ...mapActions({
      // 契約の信販か自社割賦かのステータス更新
      user: 'auth/user',
      // 契約の信販か自社割賦かのステータス更新
      updateHasPayment: 'status/updateHasPayment',
      // 契約の申込のステータス更新
      updateHasRegistration: 'status/updateHasRegistration',
      // 元の信用保証申込ID更新
      updateOriginalContractId: 'status/updateOriginalContractId',
      // 申込ユーザーID更新
      updateId: 'customer/updateId',
      // ユーザーサインデータ更新
      updateSign: 'sign/setData',
      // formの値を設定
      productInputSetForm: 'productInput/setForm',
      userInputSetForm: 'userInput/setForm',
      uploadInputSetForm: 'uploads/setForm'
    }),
    dateFormat(val, format) {
      if (val && format) {
        return moment(val).format(format)
      }
      return ''
    },
    showCancelNotice(detail) {
      /**
       * キャンセル可能日時表示 可否
       *
       * 1. 〆日設定有
       * 2. 立替依頼済
       * 3. 契約キャンセル可
       */
      const hasClosingSetting = this.$store.state.auth.user.closing_setting ? true : false
      return detail.can_cancel && detail.tatekae_apply_at && hasClosingSetting
    }
  },
  computed: {
    ...mapGetters({
      isStore: 'auth/isStore',
      storeProducts: 'productInput/getList',
      getHasPayment: 'status/getHasPayment'
    }),
    showChangeContract() {
      // 加盟店は「信販から自社割賦へ変更」ボタンを表示しない.
      if (this.isStore) {
        return false
      }
      return this.detail.contract_status === 4000 && this.detail.has_payment === 'credit' && this.detail.branch.installment_serviceable
    },
    customer_user() {
      if (this.detail) {
        if (this.detail.customer_users) {
          if (this.detail.customer_users.length) {
            return this.detail.customer_users[0]
          }
        }
      }
      return {}
    },
    showCancelBtn() {
      if (this.detailId) {
        if (!this.detail.can_cancel) {
          return false
        }
      }
      return true
    },
    isCancelable() {
      return this.$store.state.auth.user.cancelable
    },
    showUpdateBtn() {
      const passedStatus = [1000, 2000, 3000, 4000, 6000]

      if (this.detailId) {
        const isPassed = passedStatus.includes(this.detail.contract_status)
        return isPassed
      }
      return true
    }
  },
  beforeRouteUpdate(to, from, next) {
    // ルート変更に反応する...
    // next() を呼び出すのを忘れないでください
    next()
    this.initialize()
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/_config.scss';
.is_read {
  color: $COLOR_READED;
  margin-right: 5px;
  font-weight: normal;
}
.head_data {
  text-align: center;
  font-size: 18px;
  border-bottom: 1px solid#eee;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.message_area {
  border-bottom: 1px solid#eee;
  padding-bottom: 15px;
  margin-bottom: 5px;
  .send_btn {
    margin-top: 15px;
    text-align: right;
  }
}
div.messages {
  .message {
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid#eee;

    .signature {
      font-size: 11px;
      font-weight: bold;
      margin-bottom: 0.5rem;
      overflow: hidden;
      &.store {
        color: #666;
      }
      &.jcg {
        color: #f3980f;
        label {
          color: #f3980f;
        }
      }
    }
    .text {
      margin-bottom: 0;
      font-size: 12px;
      white-space: pre-wrap;
      word-wrap: break-word;
    }
  }
}
.cancel_notice {
  color: red;
  font-size: 12px;
}
</style>
